import {
    StateState,
    FetchState
} from "@/shared/types";
import * as UserService from "@/shared/api/userService";
import { defineStore } from "pinia";
import _ from "lodash";
import { useNotifierStore } from "@/shared/store/notifier";

export const initialState: StateState = {
    status: FetchState.Uninitialized,
    abbreviations: []
};
export const useUsStateStore = defineStore("usState", {
    state: (): StateState => (_.cloneDeep(initialState)),
    getters: {
        getUsStates: state => state.abbreviations,
        isStatesLoaded: state => state.status === FetchState.Loaded
    },
    actions: {
        setUsStates (states) {
            this.abbreviations = states;
            this.status = FetchState.Loaded;
        },
        setStatusToLoading () {
            this.status = FetchState.Loading;
        },
        resetStatus () {
            this.status = FetchState.Uninitialized;
        },
        getStatesFromApi () {
            if (this.status === FetchState.Loaded) {
                return;
            }
            this.setStatusToLoading();
            const notifierStore = useNotifierStore();
            UserService.getUsStates().then(response => {
                this.setUsStates(response.data);
            }).catch(err => {
                this.resetStatus();
                notifierStore.setDanger("Error loading state list");
            });
        }
    }
});

